import Comment from 'data/Comment';

const VENDOR_COMMENT_INITIATOR = 'VENDOR';

export const isVendorComment = (comment: Comment): boolean =>
  (comment.initiatedBy || '').toUpperCase() === VENDOR_COMMENT_INITIATOR;
